// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  BodyUploadAttachment,
  GenericApiResponseAttachmentDeleteResponse,
  GenericApiResponseAttachmentUploadResponse,
  GenericApiResponseListAttachment,
  HTTPValidationError,
} from '../../models';

/**
 * Get list of attachments for specific task for current user
 * @summary Get Attachments
 */
export const getAttachments = (
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListAttachment>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submissions/attachments`, options);
};

export const getGetAttachmentsQueryKey = (courseId: string, moduleId: string, taskId: string) => {
  return [`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submissions/attachments`] as const;
};

export const getGetAttachmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttachments>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachments>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAttachmentsQueryKey(courseId, moduleId, taskId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttachments>>> = ({ signal }) =>
    getAttachments(courseId, moduleId, taskId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(courseId && moduleId && taskId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttachments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAttachments>>>;
export type GetAttachmentsQueryError = AxiosError<HTTPValidationError>;

export function useGetAttachments<
  TData = Awaited<ReturnType<typeof getAttachments>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachments>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAttachments>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAttachments<
  TData = Awaited<ReturnType<typeof getAttachments>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachments>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAttachments>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAttachments<
  TData = Awaited<ReturnType<typeof getAttachments>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachments>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Attachments
 */

export function useGetAttachments<
  TData = Awaited<ReturnType<typeof getAttachments>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttachments>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAttachmentsQueryOptions(courseId, moduleId, taskId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload a file for a specific task submission
 * @summary Upload Attachment
 */
export const uploadAttachment = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bodyUploadAttachment: BodyUploadAttachment,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseAttachmentUploadResponse>> => {
  const formData = new FormData();
  formData.append('file', bodyUploadAttachment.file);

  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submissions/attachments`,
    formData,
    options,
  );
};

export const getUploadAttachmentMutationOptions = <
  TData = Awaited<ReturnType<typeof uploadAttachment>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: BodyUploadAttachment },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['uploadAttachment'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadAttachment>>,
    { courseId: string; moduleId: string; taskId: string; data: BodyUploadAttachment }
  > = (props) => {
    const { courseId, moduleId, taskId, data } = props ?? {};

    return uploadAttachment(courseId, moduleId, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: BodyUploadAttachment },
    TContext
  >;
};

export type UploadAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAttachment>>>;
export type UploadAttachmentMutationBody = BodyUploadAttachment;
export type UploadAttachmentMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Upload Attachment
 */
export const useUploadAttachment = <
  TData = Awaited<ReturnType<typeof uploadAttachment>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; data: BodyUploadAttachment },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; data: BodyUploadAttachment },
  TContext
> => {
  const mutationOptions = getUploadAttachmentMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete uploaded attachment
 * @summary Delete Attachment
 */
export const deleteAttachment = (
  courseId: string,
  moduleId: string,
  taskId: string,
  attachmentId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseAttachmentDeleteResponse>> => {
  return axios.delete(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/submissions/attachments/${attachmentId}`,
    options,
  );
};

export const getDeleteAttachmentMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteAttachment>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; attachmentId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteAttachment'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAttachment>>,
    { courseId: string; moduleId: string; taskId: string; attachmentId: string }
  > = (props) => {
    const { courseId, moduleId, taskId, attachmentId } = props ?? {};

    return deleteAttachment(courseId, moduleId, taskId, attachmentId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; attachmentId: string },
    TContext
  >;
};

export type DeleteAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttachment>>>;

export type DeleteAttachmentMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Attachment
 */
export const useDeleteAttachment = <
  TData = Awaited<ReturnType<typeof deleteAttachment>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; attachmentId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; attachmentId: string },
  TContext
> => {
  const mutationOptions = getDeleteAttachmentMutationOptions(options);

  return useMutation(mutationOptions);
};
